'use strict';

const React = require('react');
const PropTypes = require('prop-types');

class GridBase extends React.Component {
    _getHeader() {
        return null;
    }

    _getItems() {
        return null;
    }

    _getViewAll() {
        return null;
    }

    _setQuickViewId(id) {
        this.setState({
            quickViewItemId: id,
        });
    }

    _renderGrid() {
        return (
            <div>
                {this._getHeader()}
                <div className="rowFlex">{this._getItems()}</div>
                {this._getViewAll()}
            </div>
        );
    }

    _renderDarkGrid() {
        return (
            <div
                className="pdp-grid-dark primary-viewport-width"
                data-tn="pdp-similar-recommendation-grid"
            >
                <div className="primary-page-width">{this._renderGrid()}</div>
            </div>
        );
    }

    cancelLazyLoad() {
        this.setState({
            loadLazyImages: true,
        });
    }

    render() {
        const items = this._getItems();
        const grid = this.props.darkGrid ? this._renderDarkGrid() : this._renderGrid();
        // Only render if there are items to display.
        if (!items.length) {
            return null;
        }

        return grid;
    }
}

GridBase.propTypes = {
    darkGrid: PropTypes.bool,
};

GridBase.defaultProps = {
    darkGrid: false,
};

GridBase.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func,
};

module.exports = GridBase;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridBase.jsx